export default {
    manage_createEditLocation_EditTitle: "Actualizar Ubicación:",
    manage_createEditLocation_CreateTitle: "Crear Ubicación",
    manage_createEditLocation_success: "La Ubicación fue creada exitosamente",
    manage_createEditLocation_success_edit: "La Ubicación fue actualizada exitosamente",
    manage_createEditLocation_duplicatedLocationErrorMessage: "Este Ubicación ya existe",
    manage_createEditLocation_TitleInputLabel: "Nombre de Ubicación",
    manage_createEditLocation_AddressInputLabel: "Dirección",
    manage_createEditLocation_EnabledELDRuleLabel: "Activar ELD 150 millas Norma",
}